/* global textBtnVideoStop, textBtnVideoPlay */

const bannerVideo = document.querySelector('.banner-video')
const buttonVideo = bannerVideo ? bannerVideo.querySelector('.button-media-player') : null
const video = bannerVideo ? bannerVideo.querySelector('video') : null
const iconVideo = buttonVideo ? buttonVideo.querySelector('i') : null
const textVideo = buttonVideo ? buttonVideo.querySelector('span') : null

function runVideo () {
    if (!video || !buttonVideo) return
    if (video.paused) {
        video.play()
        iconVideo.className = 'bi bi-pause'
        textVideo.innerText = textBtnVideoStop
    } else {
        video.pause()
        iconVideo.className = 'bi bi-play'
        textVideo.innerText = textBtnVideoPlay
    }

    buttonVideo.classList.toggle('hidden')
}

function showControl () {
    if (!buttonVideo) return
    iconVideo.className = 'bi bi-play'
    buttonVideo.classList.remove('hidden')
    textVideo.innerText = textBtnVideoPlay
}

if (video && buttonVideo) {
    video.addEventListener('ended', showControl)
    buttonVideo.addEventListener('click', runVideo)
}
